import { Component, OnInit, Input, ElementRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { tools } from '../../shared/services/tools';
import { deviceService } from '../../shared/servicesHardware/deviceService';
import { configuration } from "../../../environments/config";
import { startWith, map, first } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { FileDetails, Iemployees } from '../appel-a-support.model';
import { HttpHeaders } from '@angular/common/http';
import { PostJsonObjectService } from '../../shared/services/post-json-object.service'
import { MatDialog } from '@angular/material/dialog';
import { SnackBarMessages } from '../../snack-bar-messages/snack-bar-messages';
import { PutJsonObjectService } from '../../shared/services/put-json-object.service';
import { MaterialModule } from '../../material-module';
import { CommonModule } from '@angular/common';
import { EnvoiFichier } from '../../envoi-fichier/envoi-fichier';
import { AlertService } from '../../shared/services/alert.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-detail-appel-a-support',
  imports: [MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, EnvoiFichier],
  standalone: true,
  templateUrl: './detail-appel-a-support.html',
  styleUrls: ['./detail-appel-a-support.scss', './progress-wizard.scss']
})
export class DetailAppelASupport implements OnInit {

  @Input() appelASupport: any;
  @Input() listSociety: any;
  @Input() teamMember: any;
  @Output() componentHeight: EventEmitter<number> = new EventEmitter<number>();
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('mainDialogRight', { static: true }) public mainDialogRight!: ElementRef;

  formGroupArray: FormGroup[] = [];
  public userList: any[] = [];
  private dateLimiteDocs!: Date;
  // public appelASupport : any
  public loaded: boolean = false;
  public countSectionInDetails: number = 0;
  private canClose: boolean = false;
  public documents: any[] = [];
  public localEtatAS: number = 0;
  public companyName: string = "";
  public userListState: number = 0;
  public authorSelected: number = 0;
  public filteredOptionsNom!: Observable<string[]>;
  public employesMap = new Map<string, Iemployees>();
  public enumAS!: EtatAs;
  private storeSideNav: any


  private urlApp = "";

  constructor(
    private postJsonObjectService: PostJsonObjectService,
    private putJsonObjectService: PutJsonObjectService,
    private tools: tools,
    private alertService: AlertService,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private deviceService: deviceService) {
    this.urlApp = window.location.origin;
    if (this.urlApp.includes("localhost"))
      this.urlApp = "https://espace-client.obexto.fr";
  }

  ngOnInit() {


    this.formGroupArray[0] = this._formBuilder.group({
      nom: ['', [Validators.required, Validators.minLength(4)]],
      message: ['', [Validators.required, Validators.minLength(4)]],
    });


    this.companyName = configuration.companyName;
    this.dateLimiteDocs = new Date(Date.now());
    this.dateLimiteDocs.setDate(this.dateLimiteDocs.getDate() - 5);
    this.updateAS();

    this.filteredOptionsNom = this.formGroupArray[0].controls['nom'].valueChanges.pipe(
      startWith(''),
      map(value => this._filterUser(value)),
    );
    // this.sendEventLoad()
  }

  public getAuthorDisplayName(message: any): string {
    let idAuthor = message.authorUniqueId;
    let res = "inconnu";
    if (this.employesMap != undefined && this.employesMap.get(idAuthor) != null) {
      res = "";
      let authorEmployee: any = this.employesMap.get(idAuthor);

      if (authorEmployee?.displayName != "")
        return authorEmployee?.displayName;
      if (authorEmployee?.title != "")
        res = authorEmployee?.title + ". ";
      if (authorEmployee?.firstName != "")
        res = res + authorEmployee?.firstName + " ";
      if (authorEmployee?.lastName != "")
        res = res + authorEmployee?.lastName + " ";
    }
    if (res == "inconnu") {
      if (message?.authorDisplayName != "")
        res = message?.authorDisplayName;
    }
    return res;
  }

  public getDelegatorDisplayName(message: any): string {
    let idDelegathor = message.delegatorUniqueId;
    let res = "inconnu";
    if (this.employesMap != undefined && this.employesMap.get(idDelegathor) != null) {
      res = "";
      let delegathor: any = this.employesMap.get(idDelegathor);

      if (delegathor?.displayName != "")
        return delegathor?.displayName;
      if (delegathor?.title != "")
        res = delegathor?.title + ". ";
      if (delegathor?.firstName != "")
        res = res + delegathor?.firstName + " ";
      if (delegathor?.lastName != "")
        res = res + delegathor?.lastName + " ";
    }
    if (res == "inconnu") {
      if (message?.delegatorDisplayName != "")
        res = message?.delegatorDisplayName;
    }
    return res;
  }

  private parseEmployesList() {
    //get indice of currentSociety from society list using ticket.companyUniqueID
    let societyIndice = 0;
    this.userList = [];
    if (this.formGroupArray[0] != null)
      this.formGroupArray[0]['controls']['nom'].setValue(null);

    for (let i = 0; i < this.listSociety.length; i++) {
      if (this.listSociety[i].companyUniqueId == this.appelASupport.companyUniqueId) {
        societyIndice = i;
      }
    }
    for (let j = 0; j < this.listSociety[societyIndice]?.employees?.length; j++) {
      this.userListState = 1;
      let employe: Iemployees =
      {
        "lastName": this.listSociety[societyIndice].employees[j].lastName,
        "firstName": this.listSociety[societyIndice].employees[j].firstName,
        "title": this.listSociety[societyIndice].employees[j].title,
        "displayName": this.listSociety[societyIndice].employees[j].displayName,
        "personUniqueid": this.listSociety[societyIndice].employees[j].personUniqueId
      };
      let userDisplay = {
        name: this.generateDisplayName(employe),
        idUnique: employe.personUniqueid
      };
      this.userList.push(userDisplay);
      this.employesMap.set(this.listSociety[societyIndice].employees[j].personUniqueId, employe);
    }

    for (let i = 0; i < this.teamMember.length; i++) {
      this.userListState = 1;
      let employeTeam: Iemployees =
      {
        "lastName": "",
        "firstName": "",
        "title": "",
        "displayName": this.teamMember[i].displayName,
        "personUniqueid": this.teamMember[i].personUniqueId
      };
      this.employesMap.set(this.teamMember[i].personUniqueId, employeTeam);
    }

    if (this.appelASupport.conversation[0] != null && this.employesMap.get(this.appelASupport.conversation[0].authorUniqueId) != null) {
      // let employePreSelected: Iemployees = this.employesMap.get(this.appelASupport.conversation[0].authorUniqueId)
      if (this.formGroupArray[0] != null)
        this.formGroupArray[0]['controls']['nom'].setValue(this.appelASupport.conversation[0].authorUniqueId);
    }
  }

  public confirmTicket(ticket: any) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    ticket.closeDateTimeUtc = new Date().toISOString();

    this.putJsonObjectService.sendJson("support/tickets/" + ticket.ticketUniqueId, ticket, httpOptions).pipe(
      first()).subscribe(
        result => {
          if (result == "ko") {
            this.alertService.error({ "subType": "500", "message": "Timeout error " })
          }
          else {
            result.conversation = ticket.conversation; //conversation message is not resend
            this.appelASupport = result;
          }
        });
  }

  private generateDisplayName(user: Iemployees): string {
    let userdisplay: string = "";
    if (user.displayName != "")
      return (user.displayName);
    if (user.title != "")
      userdisplay = user.title + ". ";
    if (user.firstName != "")
      userdisplay = userdisplay + user.firstName + " ";
    if (user.lastName != "")
      userdisplay = userdisplay + user.lastName;
    return userdisplay;
  }

  private _filterUser(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.userList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  public updateFormDeclarant(ev: any, componentid: any) {
    if (ev.isUserInput && componentid === 'nom') {
      this.formGroupArray[0]['controls']['nom'].setValue(ev.source.value);
      // this.listContrat(ev.source.value);
    }
  }

  public ngOnChanges(changes: any) {
    this.updateAS();
  }

  public updateAS() {

    this.loaded = true;
    if (this.appelASupport?.attachments?.length > 0)
      this.documents = this.appelASupport.attachments;
    else
      this.documents = [];

    this.parseEmployesList();
    this.sendEventLoad();
  }

  private async sendEventLoad() {
    await this.tools.delay(150); //unable to find the right moment in angular lifecycle for send event (height window after html update) after change => use timer instead 
    this.componentHeight.emit(this.mainDialogRight.nativeElement.offsetHeight);
  }

  public incCountSection() {
    this.countSectionInDetails++;
  }

  public getReadableSize(bytes: number, si: boolean) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
    var units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    var u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
  }

  public fileIsNew(document: FileDetails): boolean {
    let dateDoc = new Date(document.datePublication);
    if (this.dateLimiteDocs.getDate() - dateDoc.getDate() < 0)
      return true;
    else
      return false;
  }

  public iconParse(fullFileName: string): string {
    let splitesStr = fullFileName.split('.');
    let strReturn = splitesStr[splitesStr.length - 1].toLowerCase();

    return strReturn;
  }

  public updateFilesSended(filesAreSended: any) {

    if (filesAreSended == false)
      this.canClose = false;
    else {
      //check 
      this.canClose = true;
      this.appelASupport.attachments.push(filesAreSended);
    }
  }


  public encodeURI(doc: any): string {
    return encodeURI(environment.url + "support/attachments/" + doc.fileUniqueId + "?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser);
  }

  public generateDate(mois: number, jour: number): string {
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"
    ];
    return jour.toString() + " " + monthNames[mois - 1];
  }

  public closeSidenav() {
    this.closeEvent.emit(true);
  }

  public addMessage() {
    let message = "";
    if (this.formGroupArray[0]['controls']['message'].value != null)
      message = this.formGroupArray[0]['controls']['message'].value;

    let authorUniqueId = "";
    if (this.formGroupArray[0]['controls']['nom'].value != null)
      authorUniqueId = this.formGroupArray[0]['controls']['nom'].value;

    let objectTosend =
    {
      "message": message,
      "authorUniqueId": authorUniqueId,
      "delegatorUniqueId": ""
    };

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    this.postJsonObjectService.sendJson("support/tickets/" + this.appelASupport.ticketUniqueId + "/messages", objectTosend, httpOptions).pipe(
      first()).subscribe(
        result => {
          if (result != "ko") {
            //todo : add message to current AS
            this.appelASupport.conversation.push(result);
            this.formGroupArray[0].controls['message'].setValue("");
          }
          else {
            this.alertService.error({ "subType": "500", "message": "Timeout error " })
          }
        });
  }

}

export enum EtatAs {
  // CREA = "Appel créé",
  // RCPT = "Appel réceptionné",
  // DEMD_VALI_CLI = "Début de traitement",
  // FIN_TRMT = "Fin de traitement",
  // VALI_TRMT = "Validation ",
  // CLOT = "Cloturé"
  CREA = 1,
  RCPT,
  DEMD_VALI_CLI,
  DEB_TRMT,
  FIN_TRMT,
  VALI_TRMT,
  CLOT
}

